<template>
  <Banner 
    :title="title" 
    :image="image"
    :custom-breadcrumbs="customBreadcrumbs"
    :load-breadcrumbs="loadBreadcrumbs"
    @breadcrumbs-loaded="onBreadcrumbsLoaded"
  />
</template>

<script setup>
import { computed } from 'vue'
import Banner from "~/components/apps/Banner.vue";

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  highlight: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: ''
  },
  src: {
    type: String,
    default: ''
  },
  customBreadcrumbs: {
    type: Array,
    default: null
  },
  loadBreadcrumbs: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['breadcrumbs-loaded'])

const image = computed(() => {
  return props.image || props.src || ''
})

const onBreadcrumbsLoaded = (breadcrumbs) => {
  emit('breadcrumbs-loaded', breadcrumbs)
}
</script>